<div class="card analytics-card table-card mt-4" *ngIf="tableFormat === 'grouped' && !loading && groupedStats.length > 0">
  <div class="card-body">
    <h4 class="card-title mb-4">{{ title }}</h4>

   <div class="table-responsive-sm overflow-auto d-block" style="max-width: 100vw;">
      <table class="table table-bordered table-hover">
        <thead class="table-light">
          <tr>
            <th>{{ groupBy === 'location' ? 'Location' : 'Sales Rep' }}</th>
            <th>Boards Scanned</th>
            <th>Assigned Boards</th>
            <th>Total Cash In</th>
            <th>Total Cash Out</th>
            <th>Net Revenue</th>
            <th>Cash In / Day</th>
            <th>Net / Day</th>
            <th>Payout %</th>
            <th>RPT</th>
            <th>Turnover</th>
            <th>Credit Won</th>
            <th>Games Played</th>
            <th>Games Won</th>
            <th>Avg Bet</th>
            <th>Bet / Play</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let group of groupedStats">
            <tr>
              <td><strong>{{ group.salesRep }}</strong></td>
              <td>
                <span (click)="toggleRep(group.salesRep)" style="cursor: pointer; text-decoration: underline;">
                  {{ group.scannedBoardCount }}
                </span>
              </td>
              <td>{{ getAssignedBoardCount(group.salesRep) }}</td>
              <td>{{ group.stats.totalCashin | number:'1.0-0' }}</td>
              <td>{{ group.stats.totalCashout | number:'1.0-0' }}</td>
              <td>{{ group.stats.totalNet | number:'1.0-0' }}</td>
              <td>{{ group.stats.avgDailyCashIn | number:'1.2-2' }}</td>
              <td>{{ group.stats.avgDailyNet | number:'1.2-2' }}</td>
              <td>{{ (group.stats.totalCashin > 0 ? (group.stats.totalCashout / group.stats.totalCashin) * 100 : 0) | number:'1.1-1' }}%</td>
              <td>{{ (group.stats.totalCoinIn > 0 ? (group.stats.totalCoinOut / group.stats.totalCoinIn) : 0) | number:'1.3-3' }}</td>
              <td>{{ group.stats.totalCoinIn | number:'1.0-0' }}</td>
              <td>{{ group.stats.totalCoinOut | number:'1.0-0' }}</td>
              <td>{{ group.stats.totalGamesPlayed | number:'1.0-0' }}</td>
              <td>{{ group.stats.totalGamesWon | number:'1.0-0' }}</td>
              <td>{{ group.stats.betMultiplier | number:'1.2-2' }}</td>
              <td>{{ group.stats.betPerPlay | number:'1.2-2' }}</td>
            </tr>
<tr *ngIf="isExpanded(group.salesRep)" class="table-secondary">
  <td colspan="16">
    <table class="table mb-0">
      <thead>
        <tr>
          <th>Location</th>
          <th>Game Name</th>
          <th>Cash In</th>
          <th>Cash Out</th>
          <th>Net Revenue</th>
          <th>Cash In / Day</th>
          <th>Net / Day</th>
          <th>Payout %</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of group.stats.rawStats">
          <td>{{ s.board?.location?.locationName || 'Unknown' }}</td>
          <td>{{ s.board?.currentDeployment?.installedGamePackage?.name || '-' }}</td>
          <td>{{ s.cashInDiff | number:'1.0-0' }}</td>
          <td>{{ s.cashOutDiff | number:'1.0-0' }}</td>
          <td>{{ (s.cashInDiff - s.cashOutDiff) | number:'1.0-0' }}</td>

          <td>
            <ng-container *ngIf="s.daysSincePrevRead > 0; else dash1">
              {{ (s.cashInDiff / s.daysSincePrevRead) | number:'1.2-2' }}
            </ng-container>
            <ng-template #dash1>-</ng-template>
          </td>
          <td>
            <ng-container *ngIf="s.daysSincePrevRead > 0; else dash2">
              {{ (s.netRevenue / s.daysSincePrevRead) | number:'1.2-2' }}
            </ng-container>
            <ng-template #dash2>-</ng-template>
          </td>
          <td>
            <ng-container *ngIf="s.cashInDiff > 0; else dash3">
              {{ (s.cashOutDiff / s.cashInDiff * 100) | number:'1.1-1' }}%
            </ng-container>
            <ng-template #dash3>-</ng-template>
          </td>
        </tr>

        <!-- ✅ Subtotal Row -->
        <tr class="fw-bold">
          <td>Subtotal</td>
          <td>–</td>
          <td>{{ group.stats.totalCashin | number:'1.0-0' }}</td>
          <td>{{ group.stats.totalCashout | number:'1.0-0' }}</td>
          <td>{{ group.stats.totalNet | number:'1.0-0' }}</td>
          <td>{{ group.stats.avgDailyCashIn | number:'1.2-2' }}</td>
          <td>{{ group.stats.avgDailyNet | number:'1.2-2' }}</td>
          <td>{{ (group.stats.totalCashin > 0 ? (group.stats.totalCashout / group.stats.totalCashin * 100) : 0) | number:'1.1-1' }}%</td>
        </tr>
      </tbody>
    </table>
  </td>
</tr>

          </ng-container>
        </tbody>
        <tfoot class="table-light">
          <tr class="fw-bold">
            <td>Grand Total</td>
            <td>{{ getTotalScannedBoards() }}</td>
            <td>{{ getTotalAssignedBoards() }}</td>
            <td>{{ getGrandTotal().totalCashin | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalCashout | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalNet | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().avgDailyCashIn | number:'1.2-2' }}</td>
            <td>{{ getGrandTotal().avgDailyNet | number:'1.2-2' }}</td>
            <td>{{ (getGrandTotal().payoutRatio * 100) | number:'1.1-1' }}%</td>
            <td>{{ getGrandTotal().rpt | number:'1.3-3' }}</td>
            <td>{{ getGrandTotal().totalCoinIn | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalCoinOut | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalGamesPlayed | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().totalGamesWon | number:'1.0-0' }}</td>
            <td>{{ getGrandTotal().betMultiplier | number:'1.2-2' }}</td>
            <td>{{ getGrandTotal().betPerPlay | number:'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<div class="card analytics-card table-card mt-4"
     [class.flagged-stats-card]="flagged"
     *ngIf="tableFormat === 'boardStats' && !loading">
  <div class="card-body">
    <h4 class="card-title" [class.mb-4]="!flagged" [class.mb-2]="flagged">{{ title }}</h4>
    <div *ngIf="flagged" class="text-muted small mb-3">
      These rows are excluded from the main totals and averages.
    </div>

    <div class="table-responsive breakdown-table">
      <table class="table table-bordered table-hover" style="min-width: 1200px;">
        <thead>
          <tr class="totals-row" [class.table-info]="!flagged" [class.table-warning]="flagged">
            <th colspan="7"><strong>{{ flagged ? 'Flagged Totals' : 'Totals' }} ({{ boardStats.length }} Boards)</strong></th>
            <th><strong>{{ boardStats | sum:'cashInDiff' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | sum:'cashOutDiff' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | sum:'profit' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | average:'daysSincePrevRead' | number:'1.0-1' }}</strong></th>
            <th><strong>{{ boardStats | average:'cashInDiff/daysSincePrevRead' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | average:'profit/daysSincePrevRead' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ (boardStats | average:'holdPercentage') * 100 | number:'1.0-2' }}%</strong></th>
            <th><strong>{{ ((boardStats | sum:'coinOutDiff') / (boardStats | sum:'coinInDiff')) * 100 | number:'1.0-0' }}%</strong></th>
            <th><strong>{{ boardStats | sum:'coinInDiff' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | sum:'coinOutDiff' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | sum:'gamePlayedDiff' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ boardStats | sum:'gameWonDiff' | number:'1.0-0' }}</strong></th>
            <th><strong>{{ (boardStats | sum:'coinInDiff') / (boardStats | sum:'cashInDiff') | number:'1.0-2' }}</strong></th>
            <th><strong>{{ (boardStats | sum:'coinInDiff') / (boardStats | sum:'gamePlayedDiff') | number:'1.0-2' }}</strong></th>
            <th *ngIf="isRoot"></th>
          </tr>
          <tr>
            <th (click)="sortBoardStats('timeStamp')" role="button">Read Timestamp</th>
            <th (click)="sortBoardStats('assetTag')" role="button">Asset Tag</th>
            <th (click)="sortBoardStats('serialNumber')" role="button">Serial Number</th>
            <th (click)="sortBoardStats('location')" role="button">Location</th>
            <th (click)="sortBoardStats('salesRep')" role="button">Sales Rep</th>
            <th (click)="sortBoardStats('state')" role="button">State</th>
            <th (click)="sortBoardStats('gameName')" role="button">Game Name</th>
            <th (click)="sortBoardStats('cashInDiff')" role="button">Cash In</th>
            <th (click)="sortBoardStats('cashOutDiff')" role="button">Cash Out</th>
            <th (click)="sortBoardStats('profit')" role="button">Net Revenue</th>
            <th (click)="sortBoardStats('daysSincePrevRead')" role="button">Days Since Last</th>
            <th (click)="sortBoardStats('cashInPerDay')" role="button">Cash In/Day</th>
            <th (click)="sortBoardStats('netPerDay')" role="button">Net/Day</th>
            <th (click)="sortBoardStats('payout')" role="button">Payout %</th>
            <th (click)="sortBoardStats('rpt')" role="button">RPT</th>
            <th (click)="sortBoardStats('coinInDiff')" role="button">Turnover</th>
            <th (click)="sortBoardStats('coinOutDiff')" role="button">Credit Won</th>
            <th (click)="sortBoardStats('gamePlayedDiff')" role="button">Games Played</th>
            <th (click)="sortBoardStats('gameWonDiff')" role="button">Games Won</th>
            <th (click)="sortBoardStats('betMultiplier')" role="button">Bet Multiplier</th>
            <th (click)="sortBoardStats('betPerPlay')" role="button">Bet/Play</th>
            <th *ngIf="isRoot" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of sortedBoardStats" [class.table-warning]="flagged">
            <td>{{ item.timeStamp | date }}</td>
            <td>{{ item.board?.assetTag }}</td>
            <td>{{ item.board?.serialNumber }}</td>
            <td>{{ item.__locationName || item.board?.currentDeployment?.location?.locationName }}</td>
            <td>{{ item.__salesRepName || (item.board?.currentDeployment?.location?.salesRep?.firstName + ' ' + item.board?.currentDeployment?.location?.salesRep?.lastName) }}</td>
            <td>{{ item.__state || item.board?.currentDeployment?.location?.businessAddress?.state }}</td>
            <td>
              {{ item.board?.currentDeployment?.installedGamePackage?.name || item.board?.installedGamePackage?.name }}
              <div *ngIf="flagged && item.flaggedNote" class="text-danger small">
                Flagged: {{ item.flaggedNote }}
              </div>
            </td>
            <td>{{ item.cashInDiff | number:'1.0-0' }}</td>
            <td>{{ item.cashOutDiff | number:'1.0-0' }}</td>
            <td>{{ item.profit | number:'1.0-0' }}</td>
            <td>{{ item.daysSincePrevRead }}</td>
            <td>{{ item.cashInDiff / item.daysSincePrevRead | number:'1.0-0' }}</td>
            <td>{{ item.profit / item.daysSincePrevRead | number:'1.0-0' }}</td>
            <td>{{ item.holdPercentage * 100 | number:'1.0-2' }}%</td>
            <td>{{ (item.coinOutDiff / item.coinInDiff) * 100 | number:'1.0-0' }}%</td>
            <td>{{ item.coinInDiff | number:'1.0-0' }}</td>
            <td>{{ item.coinOutDiff | number:'1.0-0' }}</td>
            <td>{{ item.gamePlayedDiff | number:'1.0-0' }}</td>
            <td>{{ item.gameWonDiff | number:'1.0-0' }}</td>
            <td>{{ item.coinInDiff / item.cashInDiff | number:'1.0-2' }}</td>
            <td>{{ item.coinInDiff / item.gamePlayedDiff | number:'1.0-2' }}</td>
            <td *ngIf="isRoot" class="text-end text-nowrap">
              <button
                *ngIf="currentCategory !== null"
                class="btn btn-sm btn-outline-secondary me-1"
                (click)="categoryChange.emit({ stat: item, category: 'STANDARD' })">
                Move to Board Stats
              </button>
              <button
                *ngIf="currentCategory !== 'FUSION_LEASE'"
                class="btn btn-sm btn-outline-primary me-1"
                (click)="categoryChange.emit({ stat: item, category: 'FUSION_LEASE' })">
                Move to Lease
              </button>
              <button
                *ngIf="currentCategory !== 'PICKUP'"
                class="btn btn-sm btn-outline-info me-1"
                (click)="categoryChange.emit({ stat: item, category: 'PICKUP' })">
                Move to Pickup
              </button>
              <button
                *ngIf="currentCategory !== 'BOARD_SALES'"
                class="btn btn-sm btn-outline-dark me-1"
                (click)="categoryChange.emit({ stat: item, category: 'BOARD_SALES' })">
                Move to Board Sales
              </button>
              <button
                *ngIf="!flagged"
                class="btn btn-sm btn-outline-warning me-1"
                (click)="flagChange.emit({ stat: item, flagged: true })">
                Flag
              </button>
              <button
                *ngIf="flagged"
                class="btn btn-sm btn-outline-success me-1"
                (click)="flagChange.emit({ stat: item, flagged: false })">
                Unflag
              </button>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="deleteStat.emit(item)">
                Delete
              </button>
            </td>
          </tr>
          <tr *ngIf="boardStats.length === 0">
            <td [attr.colspan]="isRoot ? 22 : 21" class="text-center text-muted py-4">No board statistics found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
